// extracted by mini-css-extract-plugin
export default {"Essay":"index__Essay--3FdJD","essay":"index__Essay--3FdJD"};